<template>
    <div :class="sidebarCss">
        <div class="top-info">
            <i class="icon elementIcon" :class="content.class" v-html="content.icon"></i>
            {{content.title}}

        </div>
        <SubmenuLink v-for="(link, linkIdx) in content.expand"
                     :link = link
                     :idx = linkIdx
                     :key = linkIdx+link.url
        />
    </div>
</template>

<script>
    // import VTitle from 'v-title';
    import SubmenuLink from './SubmenuLink.vue'
    export default {
        name: 'SubMenu',
        props: ['content','showExpand','ismobile','ismobileexpanded'],
        computed:{
            sidebarCss:function () {
                if(this.showExpand&&!this.ismobile){
                    return 'sidebar-submenu active';
                }else if(this.ismobile && this.showExpand && this.ismobileexpanded){
                    return 'sidebar-submenu active';
                }
                return 'sidebar-submenu';
            }
        },
        components:{
            SubmenuLink
        },
        methods:{
            handleClick:function () {
                this.$emit('on-expand-element',this.element);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .sidebar-submenu {
        background-color: #313A41;
        width:245px;
        height:100%;
        color:#D6D7D8;
        text-align:left;
        position:fixed;
        top:77px;
        left:77px;
        cursor:pointer;
        z-index:2101;
        transform: translateX(-330px);
        transition: 1s;
    }
    .sidebar-submenu.active {
        display:block;
        transform: translateX(0px);

    }
    .menu-link{
        padding-left:36px;
        border-left:solid 6px #0099BC;
    }
    .menu-link.active {
        background-color:#272E34;

    }
    .sidebar-submenu .top-info{
        padding-left:36px;
        background: #96D9E7;
        background: -webkit-radial-gradient(right, #96D9E7, #009ABC);
        background: -moz-radial-gradient(right, #96D9E7, #009ABC);
        background: radial-gradient(circle at right center, #96D9E7, #009ABC);
        padding-top: 23px;
        padding-bottom: 23px;
        color:#fff;
        vertical-align: middle;
        margin-bottom:18px;
    }
    .top-info .icon.elementIcon{
        color:#fff;
        font-size:20px;

    }
</style>
<style scoped>
    /*.sidebar-submenu {*/
    /*    border-bottom:1px solid #272E34;*/
    /*    width:77px;*/
    /*    height:70px;*/
    /*    color:#fff;*/
    /*    text-align:center;*/
    /*    line-height:70px;*/
    /*    cursor:pointer;*/
    /*}*/
</style>
